import { render, staticRenderFns } from "./WheelsetRepairs.vue?vue&type=template&id=6ef46d22&scoped=true"
import script from "./WheelsetRepairs.vue?vue&type=script&lang=js"
export * from "./WheelsetRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef46d22",
  null
  
)

export default component.exports